export const INT_NULL_EMPTY_STRING_AND_SPACES_REGEX = /^\s*(?:-?\d+|null)?\s*$/i
export const INT_REGEX = /^-?\d*$/
export const POSITIVE_INT_REGEX = /^\d+$/
export const INT_RANGE_REGEX = /^\d+-\d+$/
export const SPACE_AROUND_DASH_REGEX = /\s*-\s*/g
export const INT_RANGE_WITH_SPACE_AROUND_DASH_REGEX = /^(\d+)\s*-\s*(\d+)$/
export const MAX_INT_RANGE = 10000

export const IntegerSchemaValues = {
    GREATER_OR_EQUAL: 'greater_or_equal',
    GREATER_THAN: 'greater_than',
    LESS_OR_EQUAL: 'less_or_equal',
    LESS_THAN: 'less_than',
} as const
